import {NgModule} from '@angular/core';
import {SharedModule} from '../shared/shared.module';
import {AngularMaterialModule} from '../angular-material.module';
import {LoginComponent} from 'src/app/features/authentication/components/login/login.component';
import {ForgotPasswordStep1Component} from 'src/app/features/authentication/components/forgot-password-step1/forgot-password-step1.component';
import {ForgotPasswordStep2Component} from 'src/app/features/authentication/components/forgot-password-step2/forgot-password-step2.component';
import {RegisterComponent} from 'src/app/features/authentication/components/register/register.component';
import {AuthenticationRoutingModule} from './authentication-routing.module';
import {ResendVerificationEmailComponent} from 'src/app/features/authentication/components/resend-verification-email/resend-verification-email.component';

import {ThankYouPageComponent} from './components/thank-you-page/thank-you-page.component';
import {RegisterStep1Component} from './components/register-step1/register-step1.component';

@NgModule({
  declarations: [
    LoginComponent,
    ForgotPasswordStep1Component,
    ForgotPasswordStep2Component,
    RegisterComponent,
    ResendVerificationEmailComponent,
    RegisterStep1Component,
    ThankYouPageComponent,
  ],
  imports: [
    SharedModule,
    AngularMaterialModule,
    AuthenticationRoutingModule,
  ],
})
export class AuthenticationModule {}
